import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "data-title"
};
const _hoisted_2 = {
  class: "title-container"
};
const _hoisted_3 = {
  class: "sub-title"
};
import { ElCollapse } from "element-plus";
export default {
  __name: 'RoleDataCollapse',
  props: {
    dataArray: {
      type: Array,
      required: true
    },
    dataTitle: {
      type: [String, null],
      required: false,
      default: null
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");

      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createBlock(_component_el_col, {
        style: {
          "align-items": "flex-start",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [__props.dataTitle ? (_openBlock(), _createElementBlock("text", _hoisted_1, _toDisplayString(__props.dataTitle), 1)) : _createCommentVNode("", true), _createVNode(_unref(ElCollapse), {
          class: _normalizeClass(__props.dataTitle ? 'smaller' : '')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataArray, (item, key) => {
            return _openBlock(), _createBlock(_component_el_collapse_item, {
              key: key
            }, {
              title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", {
                class: _normalizeClass(item.highlight !== 0 ? `highlight-title-${item.highlight}` : '')
              }, _toDisplayString(item.title), 3), _createElementVNode("text", _hoisted_3, _toDisplayString(item.subtitle), 1)])]),
              default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
                item: item
              })]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 3
        }, 8, ["class"])]),
        _: 3
      });
    };
  }

};